import { withAnalytics } from '@pco/analytics';
import { Drawer } from '@pco/atoms/Drawer';
import { useDrawerStore } from './useDrawerStore';

interface DrawerWithStateProps {
	drawerId: string;
	direction?: 'left' | 'right' | 'top' | 'bottom';
	children: React.ReactNode;
	title?: string;
	description?: string | React.ReactNode;
	accessibilityLabel?: string;
	headerStartContent?: React.ReactNode;
}

const DrawerWithState = ({
	drawerId,
	direction = 'left',
	headerStartContent,
	title,
	description,
	accessibilityLabel,
	children,
}: DrawerWithStateProps) => {
	const { isOpen, closeDrawer, setHeight } = useDrawerStore(drawerId);

	return (
		<Drawer
			title={title || drawerId}
			open={isOpen}
			onClose={closeDrawer}
			direction={direction}
			handleOnly
		>
			<Drawer.Content
				title={title}
				description={description}
				accessibilityLabel={accessibilityLabel}
				headerStartContent={headerStartContent}
				setHeight={setHeight}
			>
				{children}
			</Drawer.Content>
		</Drawer>
	);
};

const DrawerWithStateWithAnalytics = withAnalytics(DrawerWithState)();
export { DrawerWithStateWithAnalytics as DrawerWithState };
